module.exports = __webpack_public_path__ + "img/Revizor-Crossword-Puzzle-1-answers.5ec01752.jpg";